export default __webpack_public_path__ + "static/media/mark-sheet-template-1.0ad53207.png";